import { PLAN_BUILDER_PRODUCT_CONFIGURATIONS_SORTED } from '../actions/constants/ActionTypes';
import { productsAndPacksForQueryParamsSelector } from '../selectors/ProductConfigsSelectors';
import { setQueryParams } from '../utils/urls/appQueryParamUtilsLegacy';

/**
 * Middleware will add product configurations to the query params whenever they change (after they are sorted)
 */
export const productConfigurationsToQueryMiddleware = store => next => action => {
  const state = store.getState();
  if (PLAN_BUILDER_PRODUCT_CONFIGURATIONS_SORTED === action.type) {
    const {
      products,
      packs
    } = productsAndPacksForQueryParamsSelector(state, {
      productConfigurations: action.payload.productConfigurations
    });
    setQueryParams({
      products,
      packs
    });
  }
  return next(action);
};